import axios from "axios";

const get = () => axios.get("api/v1/settings/email-reminders");

const update = (payload) =>
  axios.put("api/v1/settings/email-reminders", payload);

const ApiEmailReminders = {
  get,
  update,
};

export default ApiEmailReminders;
